'use es6';

import createAction from 'flux-actions/createAction';
import { REQUESTED_SMART_CONTENT_FAILED, REQUESTED_SMART_CONTENT_SUCCEEDED } from './ActionTypes';
export const handleSmartContentError = createAction(REQUESTED_SMART_CONTENT_FAILED);
export const receiveSmartContent = createAction(REQUESTED_SMART_CONTENT_SUCCEEDED, smartContent => ({
  smartContent
}));